import { assign } from '@atds-legacy/lang';
import { Resource } from '@redge-media/fo-js-sdk';

const Avatars = Resource.extend({
  endpoint: 'subscribers/profiles/avatars',

  constructor: function Avatars(subscriber) {
    Resource.call(assign(this, {
      subscriber,
    }));
  },

  getPath(method) {
    if (method === 'fetchAll') {
      return `${this.endpoint}`;
    }
  },
});

export default Avatars;
